export const AUTHENTICATE = 'AUTHENTICATE'
export const UNAUTHENTICATE = 'UNAUTHENTICATE'

export const authenticate = () => {
  return (dispatch) => {
    dispatch({ type: AUTHENTICATE, authenticated: true })
  }
}
export const unauthenticate = () => {
  return (dispatch) => {
    dispatch({ type: UNAUTHENTICATE, authenticated: false })
  }
}
